import { useMemo } from 'react'

import { Channel, TimeScale, VolumeComparisonType } from 'modules/Monitoring/types'
import { UrlStateStorageKeys } from 'modules/Monitoring/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/Monitoring/url-state-storage/useHashedSearchParams'

import { TicketsVolumeDetailsControls } from '../TicketsVolumeDetailsContext'
import { getBaseDimensionValue } from '../utils/getBaseDimensionValue'

import { useTimeRangeData } from './useTimeRangeData'

export const useTicketsVolumeState = (channel: Channel, contextKey: string) => {
  const { calculateTimeRangeParams } = useTimeRangeData({
    timeRangePages: [],
    currentTimeRangeIndex: 0,
  })

  const initialState = useMemo(() => {
    const initialTimeRange = calculateTimeRangeParams({
      timeScale: TimeScale.Hourly,
      timeframeFilter: undefined,
      supportsFuture: true,
    })

    return {
      timeScale: TimeScale.Hourly,
      comparisonType: VolumeComparisonType.LastWeek,
      aggregationDimension: getBaseDimensionValue(channel),
      ...initialTimeRange,
    }
  }, [channel, calculateTimeRangeParams])

  return useHashedSearchParams<TicketsVolumeDetailsControls>({
    hashParamKey: UrlStateStorageKeys.TicketVolumeControls,
    initialState,
    contextKey,
  })
}
